import DonationWorkflowType from 'types/workflow';

export const checkIsFiatDonationType = (workflowType: DonationWorkflowType | null) => {
  const fiatDonationTypes: Array<DonationWorkflowType | null> = [DonationWorkflowType.CreditCard, DonationWorkflowType.Ach];
  const isFiatDonationType = fiatDonationTypes.includes(workflowType);
  return isFiatDonationType;
};

export default checkIsFiatDonationType;
